// Multi-role helpers (up to 3 roles per user; `role` = primary, `roles` = full list).
// Backward compatible: a user with only `role` behaves like [role].
export const rolesOf = (u) =>
  Array.isArray(u?.roles) && u.roles.length ? u.roles : (u?.role ? [u.role] : []);

export const hasAnyRole = (u, list) => rolesOf(u).some((r) => list.includes(r));

export const hasRole = (u, r) => rolesOf(u).includes(r);

// Entry-point label for the admin/management console, adapted to the user's
// highest role so each staff member sees a name matching their own console.
const ADMIN_ROLE_PRIORITY = ["super_admin", "manager", "moderator", "associate", "support"];
const CONSOLE_LABEL_BY_ROLE = {
  super_admin: "Console admin",
  manager: "Console de gestion",
  moderator: "Console de modération",
  associate: "Tableau de bord",
  support: "Console de support",
};
export const primaryAdminRole = (u) => ADMIN_ROLE_PRIORITY.find((r) => rolesOf(u).includes(r)) || null;
export const adminConsoleLabel = (u, t) => {
  const r = primaryAdminRole(u) || "super_admin";
  const fr = CONSOLE_LABEL_BY_ROLE[r] || "Console admin";
  return t ? t(`roles.console_${r}`, fr) : fr;
};
